import React from 'react'
import AppBlobCache from '../AppBlobCache'

export default class extends React.Component
{
  render() {
    var bg = this.props.bg;
    // color: "#000000"
    // src: "24_s2_op"
    // type: "video"

    var bg_type = null;
    var bg_src = null;
    var bg_color = '#000';
    if (bg)
    {
      bg_type = bg._attributes.type;
      bg_src = bg._attributes.src;
      bg_color = bg._attributes.color || '#000';
    }

    if (bg_color && bg_color.indexOf("#") < 0) {
      bg_color = '#' + bg_color;
    }

    var position = 'absolute';
    var zIndex = 1;
    if (this.props.is_modal)
    {
      position = 'fixed';
      zIndex = 100;
    }

    if (global.DEBUG)
      console.log('ASKLNDKOASND', this.props)

    if (bg_type === 'video')
    {
      return (
        <div id={'BACKGROUND'} {...this.props} style={{position: position, zIndex: zIndex, left: 0, right: 0, bottom: 0, top: 0,
          backgroundColor: bg_color,
        }}>
          {
            (
                <video allowsinlinemediaplayback={`true`} webkit-playsinline={`webkit-playsinline`} playsInline={true} autoPlay={true}
                       src={new AppBlobCache().getMediaBlobByKey(`/media/video/${bg_src}.mp4`)} style={{
                  margin: `0 auto`,
                  maxWidth: `100%`,
                  maxHeight: `100%`,
                  objectFit: `cover`,
                  position: `absolute`,
                  left: 0,
                  right: 0,
                  height:`100%`,
                }}>
                </video>
            )
          }
          {this.props.children}
        </div>
      )
    }
    return (
      <div {...this.props} style={{position: position, left: 0, right: 0, bottom: 0, top: 0,
        backgroundColor: bg_color,
        backgroundRepeat: `no-repeat`,
        backgroundSize: `contain`,
        backgroundPosition: `50% 50%`,
        backgroundImage: `url(${new AppBlobCache().getMediaBlobByKey("/media/image/" + bg_src + ".jpg")})`
      }}>
        {this.props.children}
      </div>
    );



  }

}